import { useContext } from "react";

import { RemoteConfigContext } from "@logics/providers/RemoteConfigProvider";

export const useRemoteConfigFlags = () => {
  const context = useContext(RemoteConfigContext);

  return {
    photoPermissionEnabled: context.photo_permission,
    eventNoticeEnabled: context.event_notice,
    projectFeatureEnabled: context.project_feature,
    shareMethodEnabled: context.share_method,
    hostSectionEnabled: context.host_section,
    stayIntroductionEnabled: context.stay_introduction,
  };
};
